/*
 * Copyright (c) 2025, Gather
 * https://gather.life
 */

'use client';

import { memo } from 'react';
import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

import Icon from '../icon';

import Chip from './chip.component';
import { type InputChipProps } from './chip.interface';
import { BorderRadius } from '@/theme/constants';

const InputChip = styled((props: InputChipProps) => {
  const { color = undefined, deleteIcon, fullWidth = false, onDelete, ...other } = props;

  return (
    <Chip
      color={color}
      deleteIcon={
        fullWidth ? (
          <IconButton color='transparent' size='x-small' onClick={onDelete}>
            <Icon icon='closeSmall' />
          </IconButton>
        ) : (
          deleteIcon
        )
      }
      onDelete={onDelete}
      {...other}
    />
  );
})<InputChipProps>(({ fullWidth = false, theme }) => ({
  ...(fullWidth && {
    paddingBottom: theme.spacing(5),
    paddingTop: theme.spacing(5),
    borderRadius: BorderRadius.MD,
    justifyContent: 'space-between',
    width: '100%',

    '&.Mui-disabled': {
      border: 'none',
    },
  }),
}));

export default memo(InputChip);
